module.exports = __webpack_public_path__ + "img/client-6.ee7e787c.png";